/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsRevenueInvoicesCtrl
 */
angular.module('mercury.modules.reports.revenue')
.controller('ReportsRevenueOrdersCtrl', ["$scope", "ReportPosStaff", "ReportOrders", "reporttime", "$stateParams", "$filter", "title", function($scope, ReportPosStaff, ReportOrders, reporttime, $stateParams, $filter, title) {

  $scope.ordersGraphColumns = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Orders', type: 'number', key: 'amount', filter: 'currency'}
  ];

  if ($stateParams.staffId && $stateParams.staffName) {
    title.set('Orders By ' + $stateParams.staffName);
    $scope.loading = ReportPosStaff.getOrdersByStaff(reporttime.start(), reporttime.end(), reporttime.interval(), $stateParams.staffId);
  } else {
    title.set('Orders');
    $scope.loading = ReportOrders.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval());
  }

  // Bind the report params to the scope so they can be used during navigation
  // to the individual staff orders page.
  $scope.reportParams = reporttime.params(['time', 'type']);

  $scope.loading.then(function(results) {
    $scope.orders = results;
  });
}]);
